import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-background-950 text-background-50">
      <div className="pointer-events-none absolute inset-0 opacity-20">
        <div className="absolute -right-20 -top-24 h-80 w-80 rounded-full bg-primary-500/60 blur-3xl" />
        <div className="absolute -left-16 top-1/3 h-72 w-72 rounded-full bg-accent-500/50 blur-3xl" />
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-2">
        <div>
          <span className="manga-clip inline-flex items-center gap-2 bg-accent-500 px-3 py-1 text-sm font-bold text-foreground-950">
            <i className="ri-flashlight-fill" />
            游戏情报一站掌握
          </span>
          <h1 className="mt-5 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
            新游漫画化 · 联动情报
            <span className="mt-1 block text-primary-400">第一时间抢先看</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-background-300 md:text-lg">
            可游漫画网汇聚游戏资讯与联动情报，跟进新游漫画化、版本更新漫画及活动漫画内容。热门游戏漫画化动态与联动活动，游戏情报一站掌握。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/xinyou-manhuahu"
              className="manga-clip whitespace-nowrap bg-primary-500 px-6 py-3 text-center text-base font-bold text-background-50 transition-colors hover:bg-primary-400"
            >
              浏览新游漫画化
            </Link>
            <Link
              to="/liandong-qingbao"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-600 px-6 py-3 text-base font-bold text-background-100 transition-colors hover:border-accent-500 hover:text-accent-400"
            >
              查看联动情报
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4">
          <div className="flex flex-col gap-3 md:gap-4">
            <div className="manga-clip-both overflow-hidden rounded-md bg-background-900 p-3 md:p-4">
              <span className="text-xs text-accent-400">热点追踪</span>
              <p className="mt-1 font-heading text-lg leading-snug text-background-50">联动公报告捷</p>
            </div>
            <div className="overflow-hidden rounded-md">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20fantasy%20game%20crossover%20comic%20art%2C%20warrior%20heroine%20with%20golden%20dragon%2C%20vibrant%20ink%20painting%20style%2C%20warm%20orange%20and%20gold%20palette%2C%20dynamic%20pose%2C%20rich%20detail%2C%20clean%20background&width=640&height=520&seq=keyou-hero-01&orientation=portrait"
                alt="《圣域·御风》联动漫画视觉图"
                title="《圣域·御风》联动漫画视觉图 - 可游漫画网"
                className="h-44 w-full object-cover object-top md:h-52"
              />
            </div>
          </div>
          <div className="flex flex-col gap-3 md:gap-4">
            <div className="overflow-hidden rounded-md">
              <img
                src="https://readdy.ai/api/search-image?query=manga%20illustration%20of%20a%20strategic%20rpg%20hero%20with%20magical%20hourglass%2C%20fantasy%20world%2C%20warm%20orange%20and%20teal%20colors%2C%20comic%20style%2C%20clean%20background&width=640&height=460&seq=keyou-hero-02&orientation=landscape"
                alt="《时弦之境》漫画化首话"
                title="《时弦之境》漫画化首话 - 可游漫画网"
                className="h-40 w-full object-cover object-top md:h-48"
              />
            </div>
            <div className="manga-clip-both overflow-hidden rounded-md bg-primary-700 p-3 md:p-4">
              <span className="text-xs text-accent-200">版本更新</span>
              <p className="mt-1 font-heading text-lg leading-snug text-background-50">3.0大版本上线</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}